export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Learn CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive Web design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive ",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        "tag": "Most popular",
        "courses": [
            {
                "heading": "Java",
                "description": "This course introduces the fundamentals of Java programming, covering key concepts such as syntax, variables, and control structures.",
                "level": "Beginner",
                "lessionNumber": 6
            },
            {
                "heading": "Python",
                "description": "This course covers Python basics, including syntax, data types, and functions, for beginners in programming.",
                "level": "Beginner",
                "lessionNumber": 6
            },
            {
                "heading": "SCSS",
                "description": "This course teaches how to use SCSS for styling, including variables, nesting, and advanced CSS techniques.",
                "level": "Beginner",
                "lessionNumber": 6
            }
        ]
    },
    {
        "tag": "Skills paths",
        "courses": [
            {
                "heading": "Flask",
                "description": "Learn how to build web applications using Flask, a lightweight Python web framework for creating dynamic websites.",
                "level": "Beginner",
                "lessionNumber": 6
            },
            {
                "heading": "Django",
                "description": "This course dives into Django, focusing on building robust web applications with a focus on backend development.",
                "level": "Beginner",
                "lessionNumber": 6
            },
            {
                "heading": "Fast API",
                "description": "Discover FastAPI, a modern framework for building APIs with Python, focused on performance and ease of use.",
                "level": "Beginner",
                "lessionNumber": 6
            }
        ]
    },
    {
        "tag": "Career paths",
        "courses": [
            {
                "heading": "Next.js",
                "description": "Learn the ins and outs of Next.js, a React-based framework for building dynamic and server-rendered web applications.",
                "level": "Beginner",
                "lessionNumber": 6
            },
            {
                "heading": "Nuxt.js",
                "description": "Explore Nuxt.js for building server-side rendered applications with Vue.js, enabling better SEO and faster performance.",
                "level": "Beginner",
                "lessionNumber": 6
            },
            {
                "heading": "Sanity",
                "description": "Understand how to use Sanity for structured content management and integrating it into web applications.",
                "level": "Beginner",
                "lessionNumber": 6
            }
        ]
    }
    
]